// jQuery wrapper
(function($) {

    /**
	 ** Document ready
	 **/
	$(document).ready(function(){

		$('body').addClass('active');

		
		// Header Style


		// Header bar scrolled
		scrollbarState();

		// Reviews - Filter scroll state
		if ($('#category-filter').length > 0) {
			categoryFilterBarState();
		}


		$('.consultation-toggle').click(function() {
			$('#consultation-popup').toggleClass('show');
		});


        // Menu - Hamburger
		$('.hamburger').click(function() {
			var target = $(this).data('target');

			// If any menus open (icon active)
			if ( $('body').hasClass('menu-open') ) {
				$(this).removeClass('is-active');

				$('body').removeClass('menu-open parent-menu-open sub-menu-open child-menu-open');
				$('#main-menu-sub').removeClass('open');
				$('#main-menu-sub .sub-menu').removeClass('current');
				$('#main-menu-sub .child-menu').removeClass('current');

				$('#mobile-menu').removeClass('bg-tan bg-gold bg-bronze bg-black').addClass('bg-white');
				$('#mobile-menu a').removeClass('is-active');
				$('#mobile-menu .mobile-child-menu').removeClass('current');

				$('.hasSub > a').removeClass('current');

			// If none open
			} else {
				$(this).addClass('is-active');

				$('body').addClass('menu-open parent-menu-open');
			}
		});
		// Menu - Level 2
		$('.hasSub > a').click(function() {
			event.preventDefault();

			$('.hasSub > a').removeClass('current');
			$(this).addClass('current');
			
			var target = $(this).attr('href');
			var colour = $(this).data('colour');

			$('.hamburger').addClass('is-active');

			$('body').addClass('menu-open sub-menu-open');
			$('body').removeClass('parent-menu-open child-menu-open');
			
			$('#main-menu-sub').addClass('open');
			$('#main-menu-sub .sub-menu').removeClass('current');
			$('#main-menu-sub .child-menu').removeClass('current');
			$(target).addClass('current');

			$('#mobile-menu').removeClass('bg-white bg-tan bg-gold bg-bronze bg-black');
			if ( colour ) {
				$('#mobile-menu').addClass('bg-' + colour);
			} else {
				$('#mobile-menu').addClass('bg-white');
			}
		});
		// Menu - Level 3
		$('.hasChild > a').click(function() {
			event.preventDefault();
			
			var target = $(this).attr('href');
			var colour = $(this).data('colour');

			$('.sub-menu-container .nav-link').removeClass('is-active');
			$('#mobile-menu .nav-link').removeClass('is-active');
			$(this).addClass('is-active');

			$('body').addClass('child-menu-open');
			$('#main-menu-sub .child-menu').removeClass('current');
			$('#mobile-menu .mobile-child-menu').removeClass('current');
			$(target).addClass('current');

			$('#mobile-menu').removeClass('bg-white bg-tan bg-gold bg-bronze bg-black');
			if ( colour ) {
				$('#mobile-menu').addClass('bg-' + colour);
			} else {
				$('#mobile-menu').addClass('bg-white');
			}
		});
		// Close sub-menus
		$('#main-menu .close').click(function() {
			$('.hamburger').removeClass('is-active');

			$('body').removeClass('menu-open sub-menu-open parent-menu-open child-menu-open');

			$('#main-menu-sub').removeClass('open');
			$('#main-menu-sub .sub-menu, #main-menu-sub .child-menu').removeClass('current');
			
			$('#mobile-menu .mobile-child-menu').removeClass('current');
		});



		// Smooth Scroll
		$('a.smooth-scroll, button.smooth-scroll').on('click', function(event) {
			event.preventDefault();
			var target = $(this).data('target');
			var headerHeight = $('#site-header').outerHeight();
			var scrollPosition = $(target).offset().top - (headerHeight + 20);
			// var scrollPosition = $(target).offset().top;

			// console.log(headerHeight);

			$('html').animate({
	            scrollTop: scrollPosition
	        }, 1000);
		});


		// Homepage - Condition Categories section
		if ( $('#conditions-journey').length > 0 ) {
			$('#conditions-journey .card').hover(function() {
				$('#conditions-journey .card').not($(this)).removeClass('active').addClass('inactive');
				$(this).addClass('active').removeClass('inactive');
			});			
		}


		// Image modals
	    $('.img-modal-toggle').click( function() {
	    	var target = $(this).data('target');
	    	var parent = $(this).data('parent');
	    	var image = $(this).data('image');

	    	$(target).modal('toggle');
	    	$(parent + ' .modal-images .img').removeClass('show');
	    	$(parent + ' ' + image).addClass('show');
	    });
	    $('.img-modal-nav').click( function() {
	    	var parent = $(this).data('parent');
	    	var image = $(this).data('image');
	    	$(parent + ' .modal-images .img').toggleClass('show');
	    	// $(parent + ' ' + image).addClass('show');
	    });


		// Video modal toggle open/closed
	    $('.video-toggle').click( function() {
	    	var target = $(this).data('target');
	    	$(target).modal('toggle');
	    });
    	// Video modal - Empty player on close	    
        $('.close-video').click( function() {
        	$('.video-container').empty();
        });


		// Patient Gallery - Isotope		
		if ( $('#gallery-list').length > 0) {
			$('.filter-toggle').click( function() {
				$('.gallery-filter-wrap').toggleClass('open');
			});

			// Setup output for testing
			// var $output = $('#output');

			// filter with selects and checkboxes
			var $checkboxes = $('#gallery-filter input');

			$checkboxes.change( function() {
				// map input values to an array
				var inclusives = [];
				// inclusive filters from checkboxes
				$checkboxes.each( function( i, elem ) {
					// use value if checked
					if ( elem.checked ) {
					inclusives.push( elem.value );
					}
				});
				// combine inclusive filters
				var filterValue = inclusives.join(','); // Use join('') to change filters to AND
				// set filter in hash
				location.hash = 'filter=' + encodeURIComponent( filterValue );
			});

			// Isotope list
			var $container = $('#gallery-list').imagesLoaded( { background: true, } );

			function onHashchange() {
				var hashFilter = getHashFilter();

				// Print selection to #output for testing
				// $output.text( hashFilter || '*' );

				// filter isotope
				$container.isotope({
					itemSelector: '.gallery-item',
					filter: hashFilter,
				});
			}

			$(window).on( 'hashchange', onHashchange );

			// init Isotope with hash filter
			onHashchange();

			// set initial checkboxes from hash
			var hashFilter = getHashFilter();
			if ( hashFilter ) {
				var filters = hashFilter.split(',');
				filters.forEach( function( filter ) {
					var $checkbox = $checkboxes.filter('[value="' + filter + '"]');
					$checkbox.attr( 'checked', 'checked' );
				});
			}

			function getHashFilter() {
				var hash = location.hash;
				// get filter=filterName
				var matches = location.hash.match( /filter=([^&]+)/i );
				if ( !matches ) {
					return '';
				}
				return decodeURIComponent( matches[1] );
			}
		}


		// News filter - Select2
		if ( $('#news-filter').length > 0 ) {
			$('#cat').select2({
				minimumResultsForSearch: Infinity,
				allowClear: false,
				width: '100%',
				placeholder: 'Category',
				//dropdownCssClass: 'filter_dropdown',
			});
		
			$('#archives-dropdown-2').select2({
				minimumResultsForSearch: Infinity,
				allowClear: false,
				width: '100%',
				placeholder: 'Archive',
				//dropdownCssClass: 'filter_dropdown',
			});
		}

		// Treatment filter
		if ($('#category-filter').length > 0) {
			$('#category-filter select').select2({
				minimumResultsForSearch: Infinity,
				allowClear: false,
				width: '100%',
				// placeholder: 'Filter',
				//dropdownCssClass: 'filter_dropdown',
			});

			$('#category-filter .treatment-category-filter').on('change', function() {
				var val = $(this).val();
				console.log(val);
				if ( val != '#' ) {
					// window.location.href = window.location.host + "/" + val;
					window.location = val;
				}
			});
		}

		// Reviews filter
		if ($('#reviews-filter').length > 0) {
			$('#reviews-filter select').select2({
				minimumResultsForSearch: Infinity,
				allowClear: false,
				width: '100%',
				// placeholder: 'Filter',
				//dropdownCssClass: 'filter_dropdown',
			});

			$('#reviews-filter .review-category-filter').on('change', function() {
				var val = $(this).val();
				console.log(val);
				if ( val != '#' ) {
					// window.location.href = window.location.host + "/" + val;
					window.location = val;
				}
			});
		}

		// Read More - expanding content
		if ( $('.read-more-content').length > 0) {
			readMoreExpander();
		}
		// Ajax Load More - Run readMoreExpander after successful load
		if ($('#reviews-filter').length > 0) {
			window.almComplete = function(alm){
				readMoreExpander();
			};
		}


		// Multi-step form progress 
		if ($('.page-contact .gf_progressbar_wrapper').length > 0) {
			if ( $('.gf_progressbar_percentage').hasClass('percentbar_25') ) {
				$('.consultation-counter .step').removeClass('current');
				$('.consultation-counter .step.count-1').addClass('current visible');
				$('.consultation-counter .step.count-2').addClass('visible');
			}

			$( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
			    if ( currentPage == 2 ) {
			    	$('.consultation-counter .step').removeClass('current visible');
					$('.consultation-counter .step.count-2').addClass('current visible');					
					$('.consultation-counter .step.count-3').addClass('visible');
			        // console.log('page 2');
			    } else if ( currentPage == 3 ) {
					$('.consultation-counter .step').removeClass('current visible');
					$('.consultation-counter .step.count-3').addClass('current visible');
					$('.consultation-counter .step.count-4').addClass('visible');
			        //console.log('page 3');
			    } 
			    else if ( currentPage == 4 ) {
					$('.consultation-counter .step').removeClass('current visible');
					$('.consultation-counter .step.count-3').addClass('visible');
					$('.consultation-counter .step.count-4').addClass('current visible');
			        //console.log('page 4');
			    } 
			} );
		}


        /***
		 * Carousels
		 ***/

		// Hero Carousel
		if ($('.hero-carousel').length > 0) {
			$('.hero-carousel').slick({
				adaptiveHeight: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.hero-prev'),
				nextArrow: $('.hero-next')
			});
		}

		// Featured Treatment Carousel
		if ($('.patient-video-carousel').length > 0) {
			$('.patient-video-carousel').slick({
				adaptiveHeight: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: false,
				arrows: false,
				infinite: true,
				centerMode: false,
				// prevArrow: $('.treatment-prev'),
				// nextArrow: $('.treatment-next'),
				asNavFor: $('.patient-video-controls')
			});

			$('.patient-video-controls').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.patient-video-prev'),
				nextArrow: $('.patient-video-next'),
				asNavFor: $('.patient-video-carousel')
			});
		}

		// Featured Treatment Carousel
		if ($('.treatment-carousel').length > 0) {
			$('.treatment-carousel').slick({
				adaptiveHeight: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: false,
				arrows: false,
				infinite: true,
				centerMode: false,
				// prevArrow: $('.treatment-prev'),
				// nextArrow: $('.treatment-next'),
				asNavFor: $('.treatment-controls')
			});

			$('.treatment-controls').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.treatment-prev'),
				nextArrow: $('.treatment-next'),
				asNavFor: $('.treatment-carousel')
			});
		}

		// Health Treatment & Condition Carousel
		if ( $('.health-treatment-carousel').length > 0) {
			$('.health-treatment-carousel').slick({
				adaptiveHeight: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: false,
				arrows: false,
				infinite: true,
				centerMode: false,
				asNavFor: $('.health-treatment-controls, .health-treatment-mob-controls')
			});

			$('.health-treatment-controls').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.health-treatment-prev'),
				nextArrow: $('.health-treatment-next'),
				asNavFor: $('.health-treatment-carousel, .health-treatment-mob-controls')
			});

			$('.health-treatment-mob-controls').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.health-treatment-mob-prev'),
				nextArrow: $('.health-treatment-mob-next'),
				asNavFor: $('.health-treatment-carousel, .health-treatment-controls')
			});
		}

		// Testimonial Carousel
		if ($('.testimonial-carousel').length > 0) {
			$('.testimonial-carousel').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: true,
				arrows: false,
				infinite: true,
				centerMode: false,
				asNavFor: $('.testimonial-controls, .testimonial-mob-controls'),
			});

			$('.testimonial-controls').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: false,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.testimonial-prev'),
				nextArrow: $('.testimonial-next'),
				asNavFor: $('.testimonial-carousel, .testimonial-mob-controls')
			});

			$('.testimonial-mob-controls').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: false,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.testimonial-mob-prev'),
				nextArrow: $('.testimonial-mob-next'),
				asNavFor: $('.testimonial-carousel, .testimonial-controls')
			});
		}

		// Reviews Carousel
		if ($('.reviews-carousel').length > 0) {
			$('.reviews-carousel').slick({
				adaptiveHeight: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: false,
				autoplaySpeed: 5000,
				fade: true,
				arrows: false,
				infinite: true,
				centerMode: false,
				asNavFor: $('.reviews-controls, .reviews-mob-controls'),
			});

			$('.reviews-controls').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: false,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.reviews-prev'),
				nextArrow: $('.reviews-next'),
				asNavFor: $('.reviews-carousel, .reviews-mob-controls')
			});

			$('.reviews-mob-controls').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: false,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.reviews-mob-prev'),
				nextArrow: $('.reviews-mob-next'),
				asNavFor: $('.reviews-carousel, .reviews-controls')
			});
		}

		// Team Carousel
		if ($('.team-carousel').length > 0) {
			$('.team-carousel').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.team-prev'),
				nextArrow: $('.team-next'),
				asNavFor: $('.team-controls')
			});

			$('.team-controls').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: false,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.team-prev'),
				nextArrow: $('.team-next'),
				asNavFor: $('.team-carousel')
			});
		}

		// News Carousel
		if ($('.news-carousel').length > 0) {
			$('.news-carousel').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.news-prev'),
				nextArrow: $('.news-next'),
				asNavFor: $('.news-controls')
			});

			$('.news-controls').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: false,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.news-prev'),
				nextArrow: $('.news-next'),
				asNavFor: $('.news-carousel')
			});
		}


		// Publication Carousel
		if ($('.publication-carousel').length > 0) {
			$('.publication-carousel').slick({
				adaptiveHeight: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.publication-prev'),
				nextArrow: $('.publication-next'),
				responsive: [
					{
					  	breakpoint: 992,
					  	settings: {
							adaptiveHeight: true,
							autoplay: false,
						}
					}
				]
			});
		}

		// Results carousel
		if ($('.results-carousel').length > 0) {
			$('.results-carousel').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: false,
				touchMove: false,
				autoplay: true,
				autoplaySpeed: 5000,
				fade: true,
				arrows: false,
				infinite: true,
				centerMode: false,
			});
			
			$('.results-controls').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: false,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.results-prev'),
				nextArrow: $('.results-next'),
				asNavFor: $('.results-carousel')
			});
		}

		// Patient Journey - Experience video carousel
		if ($('.experience-video-carousel').length > 0) {
			$('.experience-video-carousel').slick({
				adaptiveHeight: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: false,
				// autoplaySpeed: 5000,
				fade: false,
				arrows: false,
				infinite: true,
				centerMode: false,
				asNavFor: $('.experience-video-controls'),
				responsive: [
					{
					  	breakpoint: 992,
					  	settings: {
							slidesToShow: 1
						}
					}
				]
			});

			$('.experience-video-controls').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: false,
				// autoplaySpeed: 5000,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.experience-video-prev'),
				nextArrow: $('.experience-video-next'),
				asNavFor: $('.experience-video-carousel')
			});
		}

        // Homepage - before / after carousel section
		if ($('.home-ba-carousel').length > 0) {
			$('.home-ba-carousel').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: false,
				touchMove: false,
				autoplay: false,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.home-ba-prev'),
				nextArrow: $('.home-ba-next'),
				// asNavFor: $('.ba-controls, .ba-controls-mob')
			});

            // Before / After slider (reusable class)
            $('.ba-slider').each(function() {
                var cur = $(this);
                // Adjust the slider
                var width = cur.width()+'px';
                cur.find('.resize img').css('width', width);
                // Bind dragging events
                drags(cur.find('.handle'), cur.find('.resize'), cur);
            });
		}

		// Before / after carousel
		if ($('.ba-carousel').length > 0) {
			$('.ba-carousel').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: false,
				touchMove: false,
				autoplay: false,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.ba-carousel-controls .accordion-ba-prev'),
				nextArrow: $('.ba-carousel-controls .accordion-ba-next'),
				// asNavFor: $('.ba-controls, .ba-controls-mob')
			});

			// Image navigation
			$('button[data-slide]').click(function(e) {
				e.preventDefault();
				var slideno = $(this).data('slide');
				var targetCarousel = $(this).data('target');
				$(targetCarousel + ' .ba-carousel').slick('slickGoTo', slideno - 1);
			});

            // Before / After slider (reusable class)
            $('.ba-slider').each(function() {
                var cur = $(this);
                // Adjust the slider
                var width = cur.width()+'px';
                cur.find('.resize img').css('width', width);
                // Bind dragging events
                drags(cur.find('.handle'), cur.find('.resize'), cur);
            });
		}

		// Before / After carousel inside accordion
		if ($('.accordion-ba-carousel').length > 0) {
			$('.accordion-ba-carousel').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: false,
				touchMove: false,
				autoplay: false,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				// prevArrow: $('.accordion-ba-carousel-controls .ba-prev'),
				// nextArrow: $('.accordion-ba-carousel-controls .ba-next'),
				asNavFor: $('.accordion-caption-carousel'),
			});

			$('.accordion-caption-carousel').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: false,
				touchMove: false,
				autoplay: false,
				fade: true,
				arrows: false,
				infinite: true,
				centerMode: false,
				// prevArrow: $('.accordion-ba-carousel-controls .ba-prev'),
				// nextArrow: $('.accordion-ba-carousel-controls .ba-next'),
				asNavFor: $('.accordion-ba-carousel'),
			});

			// Image navigation
			$('button[data-slide]').click(function(e) {
				e.preventDefault();
				var slideno = $(this).data('slide');
				var targetCarousel = $(this).data('target');
				$(targetCarousel + ' .accordion-ba-carousel').slick('slickGoTo', slideno - 1);
			});

            // Before / After slider (reusable class)
            $('.ba-slider').each(function() {
                var cur = $(this);
                // Adjust the slider
                var width = cur.width()+'px';
                cur.find('.resize img').css('width', width);
                // Bind dragging events
                drags(cur.find('.handle'), cur.find('.resize'), cur);
            });

			$('#overview-content .accordion-item .question').click( function() {
				$('.accordion-ba-carousel').slick('refresh');
				
				if ( $('.accordion-caption-carousel').length > 0) { 
					$('.accordion-caption-carousel').slick('refresh');					
				}
			})
		}

		// Before / after carousel with counter
		if ($('.ba-counted-carousel').length > 0) {
			$('.ba-counted-carousel').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: false,
				touchMove: false,
				autoplay: false,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.ba-counted-carousel-controls .ba-prev'),
				nextArrow: $('.ba-counted-carousel-controls .ba-next'),
				asNavFor: $('.ba-counted-controls')
			});

			// Image navigation
			$('button[data-slide]').click(function(e) {
				e.preventDefault();
				var slideno = $(this).data('slide');
				var targetCarousel = $(this).data('target');
				$(targetCarousel + ' .ba-counted-carousel').slick('slickGoTo', slideno - 1);
			});

			// Before / After slider (reusable class)
            $('.ba-slider').each(function() {
                var cur = $(this);
                // Adjust the slider
                var width = cur.width()+'px';
                cur.find('.resize img').css('width', width);
                // Bind dragging events
                drags(cur.find('.handle'), cur.find('.resize'), cur);
            });

			$('.ba-counted-controls').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: true,
				autoplay: false,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.ba-counted-prev'),
				nextArrow: $('.ba-counted-next'),
				asNavFor: $('.ba-counted-carousel')
			});
		}
		
		// Before / after carousel with counter
		if ($('.treatment-detail-carousel').length > 0) {
			$('.treatment-detail-carousel').slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: false,
				touchMove: false,
				autoplay: false,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.treatment-detail-controls .treatment-detail-prev'),
				nextArrow: $('.treatment-detail-controls .treatment-detail-next'),
				// asNavFor: $('.ba-counted-controls')
			});

			// Image navigation
			$('button[data-slide]').click(function(e) {
				e.preventDefault();
				var slideno = $(this).data('slide');
				var targetCarousel = $(this).data('target');
				$(targetCarousel + ' .treatment-detail-carousel').slick('slickGoTo', slideno - 1);
			});

			// Before / After slider (reusable class)
            $('.ba-slider').each(function() {
                var cur = $(this);
                // Adjust the slider
                var width = cur.width()+'px';
                cur.find('.resize img').css('width', width);
                // Bind dragging events
                drags(cur.find('.handle'), cur.find('.resize'), cur);
            });
		}


    }); // End Document Ready

    // On load
	$(window).on('load', function() {

		// Carousel Equal Heights
	    carouselEqualHeights();

		// Accordion List
		accordionList();
	
		// Before / After slider - Build on page load
		$('.ba-slider').each(function() {
			var cur = $(this);
			// Adjust the slider
			var width = cur.width()+'px';
			cur.find('.resize img').css('width', width);
			// Bind dragging events
			drags(cur.find('.handle'), cur.find('.resize'), cur);
		});

    });


	// On Scroll
	$(window).on('scroll', function () {

		// Header bar scrolled
		scrollbarState();

		// Reviews - Filter scroll state
		if ($('#category-filter').length > 0) {
			categoryFilterBarState();
		}

		// Patient Journey - On-page scroll navigation 
		if ( $('#journey-nav').length > 0 ) {
			// Get container scroll position
			var fromTop = $(this).scrollTop()+topMenuHeight;
			
			// Get id of current scroll item
			var cur = scrollItems.map(function(){
				if ($(this).offset().top < fromTop)
				return this;
			});
			// Get the id of the current element
			cur = cur[cur.length-1];
			var id = cur && cur.length ? cur[0].id : "";
			
			if (lastId !== id) {
				lastId = id;
				// Set/remove active class
				menuItems
					.parent().removeClass("active")
					.end().filter("[data-target='#"+id+"']").parent().addClass("active");
			}        
		}      

	});


    // On Resize
	$(window).on('resize', function () {

		// Carousel Equal Heights
	    carouselEqualHeights();

        // Before / After slider - Update sliders on resize.
		$('.ba-slider').each(function() {
			var cur = $(this);
			// Adjust the slider
			var width = cur.width()+'px';
			cur.find('.resize img').css('width', width);
			// Bind dragging events
			drags(cur.find('.handle'), cur.find('.resize'), cur);
		});

    });


	// Carousel - Equal heights
	function carouselEqualHeights() {
		$('.carousel.equal').on('setPosition', function () {
			$(this).find('.slick-slide').height('auto');
			var slickTrack = $(this).find('.slick-track');
			var slickTrackHeight = $(slickTrack).height();
			$(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
		});
	}


	// Header bar scrolled
	function scrollbarState() {
    	var navHeight = $('#site-header').outerHeight();

		if ( $(document).scrollTop() > navHeight ) {
			$('body').addClass('scrolled');
			$('#site-header').addClass('is-scrolled');
		} else {
    		$('body').removeClass('scrolled');
    		$('#site-header').removeClass('is-scrolled');
		}
	}

	// Header bar scrolled
	function categoryFilterBarState() {
    	var bannerHeight = $('.filter-banner').outerHeight();
		var headerHeight = $('.header-bar').outerHeight() + 10;

		if ( $(document).scrollTop() > bannerHeight ) {
			$('body').addClass('filter-scrolled');
			$('#category-filter').addClass('is-scrolled');
			$('#category-filter').css('padding-top', headerHeight);
		} else {
    		$('body').removeClass('filter-scrolled');
    		$('#category-filter').removeClass('is-scrolled');
			$('#category-filter').css('padding-top', 'inherit');
		}
	}


	// Accordions
	function accordionList() {
		// var allPanels = $('.accordion-list .answer');

		$('.accordion-list .answer:not(.active)').hide();

		$('.accordion-list .question').click( function() {
			var target = $(this).data('target');

			// console.log(targetParent);

			if ( $(target).hasClass('active') ) {
				$(this).removeClass('current');
				$(target).removeClass('active').slideUp(250);
			} else {
				// $('.accordion-list .question').removeClass('current');
				// $(allPanels).removeClass('active').slideUp(250);
				// $(this).closest('.answer').addClass('open');
				$(this).addClass('current');
				$(target).addClass('active').slideDown(250);
			}
			
			// Prevent default 'link' behaviour
			return false;
		});
	}


	// Read More - Expanding content
	function readMoreExpander() {
		$('.read-more').click( function() {
			var el = $('.main-content-mob'),
				target = $(this).data('target'),
				targetHeight = $(target).outerHeight();
				innerHeight = $(target + '.main-content-mob .inner').outerHeight();

			$(target).toggleClass('open');

			// console.log(targetHeight);
			// console.log(innerHeight);
			
			if ( $(target).hasClass('open') ) {
				$(target).css('height', innerHeight);
				$(this).html("Read Less");
			} else {
				$(target).css('height', 100);
				$(this).html("Read More");
			}
		})
	}


	// Patient Journey - on-page menu
	if ( $('#journey-nav').length > 0 ) {
		// Cache selectors
		var lastId,
		topMenu = $("#journey-nav"),
		topMenuHeight = topMenu.outerHeight()+1,
		// All list items
		menuItems = topMenu.find("button"),
		// Anchors corresponding to menu items
		scrollItems = menuItems.map(function(){
		var item = $($(this).data("target"));
		if (item.length) { return item; }
		});

		// Bind click handler to menu items
		// so we can get a fancy scroll animation
		menuItems.click(function(e){
			var target = $(this).data("target"),
				offsetTop = target === "#" ? 0 : $(target).offset().top-topMenuHeight+1;
			/*
			$('html, body').stop().animate({ 
				scrollTop: offsetTop
			}, 850);
			e.preventDefault();
			*/
		});
	}



	/*
	// Before & After - Multiple carousels with same class
	function baMultiCarousels() {
		$('.accordion-list .ba-carousel.slick-initialized').slick('unslick');

        var baMultiCarousels = $('.answer.active .ba-carousel');
	    
		baMultiCarousels.each(function() {
	        $(this).slick({
				adaptiveHeight: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: false,
				swipe: false,
				touchMove: false,
				autoplay: false,
				fade: true,
				arrows: true,
				infinite: true,
				centerMode: false,
				prevArrow: $('.ba-carousel-controls .ba-prev'),
				nextArrow: $('.ba-carousel-controls .ba-next'),
			});
		});
	} */


	// Before / After drag function
	function drags(dragElement, resizeElement, container) {
	
		// Initialize the dragging event on mousedown.
		dragElement.on('mousedown touchstart', function(e) {
		  
			dragElement.addClass('draggable');
			resizeElement.addClass('resizable');
		  
			// Check if it's a mouse or touch event and pass along the correct value
			var startX = (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;
		  
			// Get the initial position
			var dragWidth = dragElement.outerWidth(),
				posX = dragElement.offset().left + dragWidth - startX,
				containerOffset = container.offset().left,
				containerWidth = container.outerWidth();
	   
			// Set limits
			var minLeft = containerOffset + 10;
			var maxLeft = containerOffset + containerWidth - dragWidth - 10;
		  
			// Calculate the dragging distance on mousemove.
			dragElement.parents().on("mousemove touchmove", function(e) {	

				// Check if it's a mouse or touch event and pass along the correct value
				var moveX = (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;
				
				var leftValue = moveX + posX - dragWidth;
				
				// Prevent going off limits
				if ( leftValue < minLeft) {
					leftValue = minLeft;
				} else if (leftValue > maxLeft) {
					leftValue = maxLeft;
				}
				
				// Translate the handle's left value to masked divs width.
				var widthValue = (leftValue + dragWidth/2 - containerOffset)*100/containerWidth+'%';
					
				// Set the new values for the slider and the handle. 
				// Bind mouseup events to stop dragging.
				$('.draggable').css('left', widthValue).on('mouseup touchend touchcancel', function () {
					$(this).removeClass('draggable');
					resizeElement.removeClass('resizable');
				});
				$('.resizable').css('width', widthValue);

		  	}).on('mouseup touchend touchcancel', function(){

				dragElement.removeClass('draggable');
				resizeElement.removeClass('resizable');
				
		  	});
		  	e.preventDefault();

		}).on('mouseup touchend touchcancel', function(e){

			dragElement.removeClass('draggable');
			resizeElement.removeClass('resizable');

		});
	}


// end jQuery wrapper
})(jQuery);